import axios from "axios";

export const getREM = (): number => {
    const fontSize = document.documentElement.style.fontSize;
    return Number(fontSize.substring(0, fontSize.length - 2));
};

export const customScrollbar:string = window.navigator.userAgent.includes("WebKit") ? "scrollbar-webkit" : "scrollbar-firefox";

export const selectImg = (): Promise<File[]> => {
    const accept: string[] = ["jpg", "png", "jpeg"];
    const mimeType: Set<string> = new Set<string>(accept.map(a => `image/${a}`));

    return new Promise<File[]>((resolve, reject) => {
        const inputEle = document.createElement("input");
        inputEle.type = "file";
        inputEle.style.display = "none";
        inputEle.accept = accept.map(a => `.${a}`).join(",");
        inputEle.multiple = true;
        inputEle.onchange = (evt:Event) => {
            resolve(Array.from({length: inputEle.files!.length}, (v, k) => inputEle.files![k]).slice(0, 100).filter(item => mimeType.has(item.type)));
        };
        inputEle.click();
    });
}

export const delay = (miliseconds: number): Promise<void> => {
    return new Promise((resolve, _) => {
        setTimeout(resolve, miliseconds);
    });
};

export const getImgInfo = (file: File): Promise<{data: string, width: number, height: number}> => {
    return new Promise<{data: string, width: number, height: number}>((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = console.log;
        reader.onload = (e => {
            const img = new Image();
            img.onerror = console.log;
            img.onload = () => {
                resolve({data: img.src, width: img.width, height: img.height});
            };
            img.src = e.target!.result as string;
        });
        reader.readAsDataURL(file);
    });
};

// 无裁剪
export const clipImgDummy = (url: string, preferWidth: number, preferHeight: number, img: HTMLImageElement, canvas: HTMLCanvasElement): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        img.onerror = reject;
        img.onload = () => {
            const context2d = canvas.getContext("2d") as CanvasRenderingContext2D;
            context2d.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = img.width;
            canvas.height = img.height;
            context2d.drawImage(img, 0, 0);
            resolve(canvas.toDataURL());
        };
        img.src = url;
    });
}

// 聚焦裁剪
export const clipImgFocus = (url: string, preferWidth: number, preferHeight: number, img: HTMLImageElement, canvas: HTMLCanvasElement): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        img.onerror = reject;
        img.onload = () => {
            const context2d = canvas.getContext("2d") as CanvasRenderingContext2D;
            context2d.clearRect(0, 0, canvas.width, canvas.height);
            
            canvas.width = preferWidth;
            canvas.height = preferHeight;
            if(img.width / img.height < preferWidth / preferHeight){
                const scale = preferWidth / img.width;
                context2d.drawImage(img, 0, (img.height - preferHeight / scale) / 2, img.width, preferHeight / scale, 0, 0, preferWidth, preferHeight);
            } else {
                const scale = preferHeight / img.height;
                context2d.drawImage(img, (img.width - preferWidth / scale) / 2, 0, preferWidth / scale, img.height, 0, 0, preferWidth, preferHeight);
            }
            resolve(canvas.toDataURL());
        };
        img.src = url;
    });
};

// 中央裁剪
export const clipImgCenter = (url: string, preferWidth: number, preferHeight: number, img: HTMLImageElement, canvas: HTMLCanvasElement): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        img.onerror = reject;
        img.onload = () => {
            const context2d = canvas.getContext("2d") as CanvasRenderingContext2D;
            context2d.clearRect(0, 0, canvas.width, canvas.height);
            
            canvas.width = preferWidth;
            canvas.height = preferHeight;
            if(img.width / img.height < preferWidth / preferHeight){
                const scale = preferHeight / img.height;
                context2d.drawImage(img, 0, 0, img.width, img.height, (preferWidth - img.width * scale) / 2, 0, img.width * scale, preferHeight);
            } else {
                const scale = preferWidth / img.width;
                context2d.drawImage(img, 0, 0, img.width, img.height, 0, (preferHeight - img.height * scale) / 2, preferWidth, img.height * scale);
            }
            resolve(canvas.toDataURL());
        };
        img.src = url;
    });
};

export const base64ToFile = (base64Str:string):File => {
    const extension = base64Str.match(/data:image\/(\S+?);/)![1];
    const imgData = atob(base64Str.substring(base64Str.indexOf(",") + 1));
    const arr = Uint8Array.from(imgData, (v, k) => imgData.charCodeAt(k));
    return new File([arr], `temp.${extension}`);
};

export const randomSeed = (min: number, max: number): number => {
    return Math.floor(Math.random() * (max - min)) + min;
}